import Typo from "../../components/common/typo/Typo";
import { CREATE_MSG, DEBI_DETAILS_MSG, FORM_FONT_STYLE } from "../constants/GlobalConstants";

export const DEBI_CREATE = [
    <Typo key={1} variant='body2' text={CREATE_MSG} color="secondary" sx={FORM_FONT_STYLE}/>
  ];

export const DEBI_DETAILS = [
  <Typo key={2} variant='body2' text={DEBI_DETAILS_MSG} color="secondary" sx={FORM_FONT_STYLE} />

]  
  